// @ts-nocheck
import { createContext, useContext } from 'react';

export const MentionContext = createContext({
  fetchDocumentDetails: null,
  fetchSharableLink: null,
  getAttributeDetails: null,
});

export const useMentionContext = () => useContext(MentionContext);
